<template>
  <section class="hr pt20">
    <ul class="bannerList">
      <li v-for="(banner, index) in bannerList" :key="index">
        <a @click="goBannerPage(banner.bannerUrl)">
          <span class="img">
            <img :src="banner.imgURL" :alt="banner.bannerName" />
          </span>
        </a>
      </li>
      <!-- <li>
        <a @click="$router.push('/event/dailyEvent')">
          <span class="img">
            <img src="@/../static/img/mw/temp/temp_banner_ev01.png" alt="출석 이벤트 배너 지금눌러 출첵하고 혜택받으세요!" />
          </span>
        </a>
      </li>
      <li>
        <a @click="$router.push('/event')">
          <span class="img">
            <img src="@/../static/img/mw/temp/temp_banner_ev02.png" alt="이벤트 배너 깨끗한 웰릭스 음식물처리기" />
          </span>
        </a>
      </li>
      <li>
        <a @click="$router.push('/theme')">
          <span class="img">
            <img src="@/../static/img/mw/temp/temp_banner_ev03.png" alt="기획전 배너 역대급 무더위! 서둘러 준비하세요!" />
          </span>
        </a>
      </li> -->
    </ul>
  </section>
</template>

<script>
import ApiService from '@/common/api.service';
export default {
  name: 'CommonBanner',
  mounted() {
    // TODO 이미지별 route 처리
    ApiService.service('GET', '/resource/banner/27')
      .then(({ data }) => {
        this.bannerList = data.result[0].bannerDtos;
      })
      .catch(({ response }) => {
        console.log(response);
      });
  },
  data() {
    return {
      bannerList: [],
    };
  },
  methods: {
    goBannerPage(bannerUrl) {
      this.$router.push(bannerUrl);
    },
  },
};
</script>
